import React from 'react';
import { Stack } from '@mui/material';
import withStyles from '@material-ui/core/styles/withStyles';
import { VTypography } from '@venti-components';
import styles from '../styles';
import VIcon from '../../../../../Venti-UI-Kit/VIcon/VIcon';

const ArtistCard = ({ classes, artist }) => {
  return (
    <a
      href={artist.spotifyProfileUrl}
      target="_blank"
      rel="noreferrer"
      className={classes.artistCard}
    >
      <img src={artist.image} alt={artist.name} className={classes.artistImage} />
      <VTypography variant="body1" weight="bold" align="center" linesNumber={1}>
        {artist.name}
      </VTypography>
      <Stack className={classes.spotifyLogo}>
        <VIcon name="spotify" size={24} />
      </Stack>
    </a>
  );
};

export default withStyles(styles)(ArtistCard);
